export default "__VITE_ASSET__E3F1iOjp__"